function shouldDisableSwipe(slideCount, screenWidth) {
  return (
    (slideCount === 1 && screenWidth >= 768) ||
    (slideCount === 2 && screenWidth >= 1280)
  );
}

function updateAllSlidersDraggable() {
  $('.testimonial-slider-2').each(function () {
    const sliderContainer = $(this).find('.oxygen-unslider-container');
    const sliderObj = sliderContainer.data('unslider');
    const slideCount = sliderContainer.find('.unslider-wrap li').length;
    const screenWidth = $(window).width();

    if (shouldDisableSwipe(slideCount, screenWidth)) {
      sliderObj.destroySwipe();
    }
  });
}

$(window).on('load resize', updateAllSlidersDraggable);
